import { useEsEntitlement, useEsOffer } from '@/hooks/useEarlySupporter';
import { EsManagePanel } from './EsManagePanel';

/**
 * Top-of-Billing slot: only the content-sized manage panel for an active upgrade.
 * New purchases start in the native Shop.
 */
export const EarlySupporterBillingSection = () => {
  const offerQuery = useEsOffer();
  const offer = offerQuery.data;
  const hasEntitlement = !!offer?.entitlement;
  const entitlementQuery = useEsEntitlement(hasEntitlement);

  if (!offer) return null;

  const entitlement = entitlementQuery.data ?? offer.entitlement;
  if (entitlement) {
    return <div className="w-full"><EsManagePanel entitlement={entitlement} currency={offer.packages[0]?.price?.currency ?? 'EUR'} /></div>;
  }
  return null;
};
